import React from 'react';
import { FaUpload } from 'react-icons/fa';
import { StatusBadge, formatDate } from './documentHelpers';

const ATTENTION = new Set(['missing', 'expired', 'expiring', 'no_expiry']);

export default function DocumentChecklist({ checklist, onUploadType, disabled }) {
    if (!checklist?.length) return null;

    const needsAttention = checklist.filter(row => ATTENTION.has(row.status)).length;

    return (
        <div className="mb-6 rounded-xl border border-gray-100 bg-white">
            <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
                <p className="text-sm font-semibold text-gray-700">Document checklist</p>
                <p className={`text-xs font-medium ${needsAttention ? 'text-red-500' : 'text-green-600'}`}>
                    {needsAttention ? `${needsAttention} need${needsAttention === 1 ? 's' : ''} attention` : 'All in order'}
                </p>
            </div>
            <ul className="divide-y divide-gray-50">
                {checklist.map(row => (
                    <li key={row.document_type_id} className="flex flex-wrap items-center gap-x-3 gap-y-1 px-4 py-2.5">
                        <div className="min-w-0 flex-1">
                            <p className="text-sm font-medium text-gray-800">
                                {row.name}
                                {row.is_required && <span className="ml-1 text-xs text-gray-400">(required)</span>}
                            </p>
                            {row.expiry_date && (
                                <p className="text-xs text-gray-500">Expires {formatDate(row.expiry_date)}</p>
                            )}
                        </div>
                        <StatusBadge status={row.status} />
                        {(row.status !== 'valid' || row.file_count === 0) && (
                            <button
                                type="button"
                                disabled={disabled}
                                onClick={() => onUploadType(row)}
                                className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs text-gray-500 hover:bg-orange-50 hover:text-[#FF5733] disabled:opacity-50"
                                title={`Upload ${row.name}`}
                            >
                                <FaUpload />
                                <span className="hidden md:inline">{row.file_count ? 'Upload new' : 'Upload'}</span>
                            </button>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}
